import PanelError from '@wandb/weave/common/components/elements/PanelError';
import {MediaString} from '@wandb/weave/common/types/media';
import {TargetBlank} from '@wandb/weave/common/util/links';
import {isUndefined} from 'lodash';
import * as React from 'react';
// eslint-disable-next-line wandb/no-deprecated-imports
import {Icon, Popup} from 'semantic-ui-react';

import DOC_URLS, {lookupDocUrl} from '../util/doc_urls';
import {useStablePanelId} from './Panel/PanelIDContext';

interface MessageMediaNotFoundProps {
  stepIndex?: number;
  mediaKey?: string;
  mediaIndex?: number;
  mediaType?: MediaString;
  basic?: boolean; // If true, shows a question mark icon with the message as a popup
}
const MessageMediaNotFound = (props: MessageMediaNotFoundProps) => {
  const stablePanelId = useStablePanelId();
  const {stepIndex, mediaKey, mediaIndex, basic} = props;
  let mediaType: string = props.mediaType || 'media';
  const docHref = lookupDocUrl(mediaType) || DOC_URLS.logs;
  if (mediaType === 'table') {
    mediaType = 'tables';
  } else if (mediaType === 'object3D') {
    mediaType = '3D objects';
  }
  const errorMessage = (
    <PanelError
      panelID={stablePanelId}
      panelViewType="Media Browser"
      mediaType={mediaType}
      className="media-missing"
      message={
        <>
          <div>
            This run didn't log {mediaType || 'media'}
            {mediaKey && ` for key "${mediaKey}", step ${stepIndex}`}
            {isUndefined(mediaIndex) ? '' : `, index ${mediaIndex}`}.{' '}
            <TargetBlank href={docHref}>Docs →</TargetBlank>
          </div>
        </>
      }
      logErrorMessage={`This run didn't log ${mediaType || 'media'}${mediaKey ? ` for key "${mediaKey}", step ${stepIndex}` : ''}${isUndefined(mediaIndex) ? '' : `, index ${mediaIndex}`}.`}
    />
  );
  return basic ? (
    <Popup
      flowing
      hoverable
      trigger={
        <Icon
          name="question circle outline"
          size="big"
          style={{margin: 'auto'}}
        />
      }
      content={errorMessage}
    />
  ) : (
    errorMessage
  );
};

export default MessageMediaNotFound;
